import { render } from "./ShareSelectionPage.vue?vue&type=template&id=5d0e8e46"
import script from "./ShareSelectionPage.vue?vue&type=script&lang=js"
export * from "./ShareSelectionPage.vue?vue&type=script&lang=js"
script.render = render

export default script